import { render, staticRenderFns } from "./distributionShoppingMall.vue?vue&type=template&id=4fa3898f"
import script from "./distributionShoppingMall.vue?vue&type=script&lang=js"
export * from "./distributionShoppingMall.vue?vue&type=script&lang=js"
import style0 from "./distributionShoppingMall.vue?vue&type=style&index=0&id=4fa3898f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports